webpackJsonp([10,35],{

/***/ 14:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'switch',
	  props: {
	    showTag: {
	      type: Boolean,
	      default: false
	    },
	    tag: {
	      type: Array,
	      default: function _default() {
	        return ['开', '关'];
	      }
	    },
	    value: {
	      type: Boolean,
	      default: true
	    }
	  },
	  methods: {
	    _handleClick: function _handleClick() {
	      this.stateSelf = !this.stateSelf;
	      this.$emit('on-click', this.stateSelf);
	      this.$emit('input', this.stateSelf);
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    }
	  },
	  computed: {
	    cssState: function cssState() {
	      var state = '';
	      if (this.showTag && !this.stateSelf) {
	        state = 'switch-tag-off';
	      } else if (!this.showTag && !this.stateSelf) {
	        state = 'switch-off';
	      } else {
	        state = 'switch-on';
	      }
	      return state;
	    }
	  },
	  watch: {
	    value: function value(newval) {
	      this.stateSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      stateSelf: this.value
	    };
	  }
	};

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(14),
	  /* template */
	  __webpack_require__(18),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "switch",
	    class: [
	      _vm.showTag ? 'switch-tag' : '',
	      _vm.cssState
	    ],
	    on: {
	      "click": _vm._handleClick
	    }
	  }, [(_vm.showTag) ? _c('span', {
	    staticClass: "on"
	  }, [_vm._v(_vm._s(_vm.tag[0]))]) : _vm._e(), _vm._v(" "), (_vm.showTag) ? _c('span', {
	    staticClass: "off"
	  }, [_vm._v(_vm._s(_vm.tag[1]))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	var _boSwitch = __webpack_require__(16);
	
	var _boSwitch2 = _interopRequireDefault(_boSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    menuVertical: _menuVertical2.default,
	    BoSwitch: _boSwitch2.default
	  },
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    path: {
	      type: String,
	      default: ''
	    },
	    dock: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: Boolean,
	      default: false
	    },
	    alias: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    onclick: function onclick() {
	      this.$emit('on-click', '');
	    },
	    _handleSwitch: function _handleSwitch(data) {
	      var _this = this;
	
	      this.$emit('on-switch', {
	        obj: this,
	        state: data
	      });
	
	      setTimeout(function () {
	        _this.$refs.sw.setState(false);
	      }, 1000);
	    },
	    off: function off() {
	      this.$refs.sw.setState(false);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(35),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', {
	    attrs: {
	      "path": _vm.path
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-switch', {
	    ref: "sw",
	    attrs: {
	      "state": _vm.state
	    },
	    on: {
	      "on-click": _vm._handleSwitch
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(183)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(280),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toast = __webpack_require__(32);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _demoswitch = __webpack_require__(27);
	
	var _demoswitch2 = _interopRequireDefault(_demoswitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'toastdemo',
	  components: {
	    Toast: _toast2.default,
	    Dmenu: _demoswitch2.default
	  },
	  methods: {
	    showtoast: function showtoast(aim) {
	      var _this = this;
	
	      switch (aim) {
	        case 'loading':
	          {
	            this.$refs.loading.open();
	            setTimeout(function () {
	              _this.$refs.loading.close();
	            }, 3000);
	            break;
	          }
	        case 'success':
	          this.$refs.success.open();break;
	        case 'failed':
	          this.$refs.failed.open();break;
	        case 'warm':
	          this.$refs.warm.open();break;
	        case 'text':
	          this.$refs.text.open();break;
	        case 'reg':
	          {
	            this.$toast.open('全局注册调用');
	            break;
	          }
	        case 'reg2':
	          {
	            this.$toast.open('全局注册调用2', 'success');
	            break;
	          }
	        case 'reg3':
	          {
	            this.$toast.open('全局注册调用控制关闭', 'loading');
	            setTimeout(function () {
	              _this.$toast.close();
	            }, 2000);
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(26)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"demo.vue","sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(174);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(39)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-e607a516!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-e607a516!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('dmenu', {
	    attrs: {
	      "name": "读取中",
	      "dock": "Loading"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('loading')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "操作失败",
	      "dock": "Failed"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('failed')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "警告",
	      "dock": "Warm"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('warm')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "操作成功",
	      "dock": "Success"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('success')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "纯文本",
	      "dock": "Text"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('text')
	      }
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "list-title"
	  }, [_vm._v("注册调用（推荐）")]), _vm._v(" "), _c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('dmenu', {
	    attrs: {
	      "name": "注册调用",
	      "dock": "Text"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('reg')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "注册调用二",
	      "dock": "Success"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('reg2')
	      }
	    }
	  }), _vm._v(" "), _c('dmenu', {
	    attrs: {
	      "name": "注册调用控制关闭",
	      "dock": "Success"
	    },
	    on: {
	      "on-switch": function($event) {
	        _vm.showtoast('reg3')
	      }
	    }
	  })], 1), _vm._v(" "), _c('toast', {
	    ref: "loading",
	    attrs: {
	      "type": "loading",
	      "content": "读取中"
	    }
	  }), _vm._v(" "), _c('toast', {
	    ref: "success",
	    attrs: {
	      "type": "success",
	      "content": "发布成功"
	    }
	  }), _vm._v(" "), _c('toast', {
	    ref: "failed",
	    attrs: {
	      "type": "failed",
	      "content": "操作失败"
	    }
	  }), _vm._v(" "), _c('toast', {
	    ref: "warm",
	    attrs: {
	      "type": "warm",
	      "content": "信息有误"
	    }
	  }), _vm._v(" "), _c('toast', {
	    ref: "text",
	    attrs: {
	      "type": "text",
	      "content": "纯文本提示"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.33f99273c8f3bff39c85.js